/*eslint-disable*/export const messages=JSON.parse("{\"textfield.label.optional\":[\"Valgfri\"]}");